// src/components/AddNovedadModal.js
import React, { useState } from 'react';
import { Button, Modal, Box, Typography, TextField, IconButton, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const AddNovedadModal = ({ open, handleClose, handleAddNovedad }) => {
  const [fecha, setFecha] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validaciones
    if (!fecha || !descripcion || !nombre || precio === '') {
      setError('Todos los campos son obligatorios');
      return;
    }
    if (!Number.isInteger(Number(precio))) {
      setError('El precio debe ser un número entero');
      return;
    }

    setError('');
    handleAddNovedad({
      fecha,
      descripcion,
      nombre,
      precio: Number(precio)
    });

    // limpiar campos
    setFecha('');
    setDescripcion('');
    setNombre('');
    setPrecio('');
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style} component="form" onSubmit={handleSubmit}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="h2">
            Agregar Nueva Novedad
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <TextField
          margin="normal"
          required
          fullWidth
          label="Fecha y Hora"
          type="text"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          label="Nombre"
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          label="Precio"
          type="number"
          value={precio}
          onChange={(e) => setPrecio(e.target.value)}
          InputProps={{ inputProps: { step: 1 } }} // solo enteros
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          multiline
          rows={4}
          label="Descripción"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
        />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Agregar Novedad
        </Button>
      </Box>
    </Modal>
  );
};

export default AddNovedadModal;
